import { loader } from 'graphql.macro'
import { intercomConnection } from '../../intercomConnection'

export default async function bulkCreateTickets ({ dataLoaders, variables }) {
  const schema = loader('./bulkCreateTickets.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  intercomConnection.trackEvent('batch_tickets_created', {})
  return response.bulkCreateTickets
}
